/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import Header from './Header/index'
import Main from './Main/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Treatment/Content/Actions/Content/StartContract/Content"
  
}) {
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 height="auto"
 dangerouslyBypassFocusLock={true}
>
{childProps => (
<React.Fragment>
<Header
{...childProps}
  viewPath={`${viewPath}/Header`}
/>
<Main
{...childProps}
  viewPath={`${viewPath}/Main`}
/>
</React.Fragment>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}